import { useToast } from '@pairy/pds-react';
import { MouseEvent } from 'react';

import useUpdateViewerPageState from '../../../../../../hooks/useUpdateViewerPageState';
import useGetFileDownloadLink from '../../../../../../hooks/useGetFileDownloadLink';
import { GOOGLE_EVENT_ID } from '../../../../../../constant/googleEventId';
import useFileDownload from '../../../../../../hooks/mutation/file/useFileDownload';
import useDownloadPdfFile from '../../../../../../hooks/useDownloadPdfFile';
import * as Styled from '../index.styles';

interface MobilePdfDownloadButtonProps {
  fileName: string;
  isBulk: boolean;
  isDownloadEnabled: boolean;
  ctaFormPage?: number;
  isRedirectCtaFormAppropriate?: boolean;
  translateKoToEn: (item: string) => string;
}

const MobilePdfDownloadButton = ({
  fileName,
  isBulk = false,
  isDownloadEnabled = false,
  ctaFormPage,
  isRedirectCtaFormAppropriate,
  translateKoToEn,
}: MobilePdfDownloadButtonProps) => {
  const toast = useToast();

  const { downloadPdfFile, isLoading } = useDownloadPdfFile();
  const { mutate: mutateFileDownload } = useFileDownload(isBulk);
  const { updateCurrentPage } = useUpdateViewerPageState();

  const { getDownloadLink } = useGetFileDownloadLink({
    handleGetDownloadSuccess: async (downloadUrl: string) => {
      await downloadPdfFile(downloadUrl, fileName, mutateFileDownload);
    },
  });

  const handleClick = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    /*유저가 폼을 제출 하기 전에 다운로드 버튼을 클릭한 경우 
    경고 메세지를 보여주고 해당 페이지로 이동시킨다 */
    if (isRedirectCtaFormAppropriate && ctaFormPage) {
      toast(`${translateKoToEn('download-alert')}`);
      updateCurrentPage(ctaFormPage);
      return;
    }

    getDownloadLink();
  };

  if (!isDownloadEnabled) {
    return null;
  }

  return (
    <Styled.MobileButton
      id={GOOGLE_EVENT_ID.download}
      variant="zinc_500"
      radius={9999}
      onClick={handleClick}
    >
      <Styled.Spinner
        id={GOOGLE_EVENT_ID.download}
        isLoading={isLoading}
        icon={isLoading ? 'ph:circle-notch' : 'ph:download-simple'}
        size={19}
        color={isLoading ? 'zinc_400' : 'black'}
      />
    </Styled.MobileButton>
  );
};

export default MobilePdfDownloadButton;
